<mat-card>
  <div class="panel-request__card-header" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <h2 class="panel-request__card-header--title">
      {{ data.name }}
    </h2>

    <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.gt-xs="end center" fxLayoutGap="16px">
      <button mat-icon-button id="showCard" fxLayoutAlign="end center" (click)="displayCard()" [disableRipple]="false">
        <mat-icon [class]="isTableHidden ? 'icon-ic_add_circle_outline' : 'icon-ic_remove_circle_outline'"></mat-icon>
      </button>
    </div>
  </div>
  <mat-card-content>
    <div class="table__wrapper">
      <table aria-label="agent-statistic" mat-table [dataSource]="dataSource" *ngIf="!isTableHidden">
        <ng-container matColumnDef="agent">
          <th mat-header-cell *matHeaderCellDef class="first-row" translate>agentStatistics.agent</th>
          <td mat-cell *matCellDef="let element" class="first-row">{{ element.establishmendId }}</td>
          <td mat-footer-cell class="first-row" *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="nameAgent">
          <th mat-header-cell *matHeaderCellDef translate>agentStatistics.nameAgent</th>
          <td mat-cell *matCellDef="let element">{{ element.userDesc }}</td>
          <td mat-footer-cell *matFooterCellDef translate>agentStatistics.total.office</td>
        </ng-container>
        <ng-container matColumnDef="numOperation">
          <th mat-header-cell *matHeaderCellDef translate>agentStatistics.numOperation</th>
          <td mat-cell *matCellDef="let element">{{ element.numOperations }}</td>
          <td mat-footer-cell *matFooterCellDef>
            {{ this.data.totalNumOperations }}
          </td>
        </ng-container>
        <ng-container matColumnDef="investment">
          <th mat-header-cell *matHeaderCellDef translate>agentStatistics.investment</th>
          <td mat-cell *matCellDef="let element">{{ element.inversion | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef>
            {{ this.data.totalInversion | transformNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="TIR">
          <th mat-header-cell *matHeaderCellDef translate>agentStatistics.TIR</th>
          <td mat-cell *matCellDef="let element">{{ element.tirAverage | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef>
            {{ this.data.totalTirAverage | transformNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="PI">
          <th mat-header-cell *matHeaderCellDef translate>agentStatistics.PI</th>
          <td mat-cell *matCellDef="let element">{{ element.termsAverage | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef>
            {{ this.data.totalTermsAverage | transformNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="totalCommissionAgent">
          <th mat-header-cell *matHeaderCellDef translate>agentStatistics.totalCommissionAgent</th>
          <td mat-cell *matCellDef="let element">{{ element.agentCommission | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef>
            {{ this.data.totalAgentCommission | transformNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="percentageCommission">
          <th mat-header-cell *matHeaderCellDef translate>agentStatistics.percentageCommission</th>
          <td mat-cell *matCellDef="let element">{{ element.percentCommission | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef>
            {{ this.data.totalPercentCommission | transformNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="totalCommission">
          <th mat-header-cell *matHeaderCellDef translate>agentStatistics.totalCommission</th>
          <td mat-cell *matCellDef="let element">{{ element.totalCommissions | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef>
            {{ this.data.totalCommissions | transformNumber }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    </div>
    <mat-paginator
      hidePageSize
      [pageSize]="15"
      [pageIndex]="page"
      (page)="savePage($event)"
      *ngIf="!isTableHidden && dataSource.data?.length > 15"
      showFirstLastButtons
    ></mat-paginator>
  </mat-card-content>
</mat-card>
